import { Middleware } from '@nuxt/types'
import { EntryCollection } from 'contentful'

interface GetArticlesPayload {
  page: string | number
  category: string | null
}

const fetchArticles: Middleware = async ({ store, params, redirect, error, route }) => {
  if (route.name === 'articles-page-id' || route.name === 'category-slug-page-id') {
    if (!params.id || params.id === '1') redirect('/examentips')
  }
  const payload: GetArticlesPayload = {
    page: params.id || 1,
    category: params.slug || null
  }
  const articles: EntryCollection<unknown> = await store.dispatch('blog/getArticles', payload)
  if (articles.total === 0) error({ statusCode: 404, message: 'This page could not be found' })
}

export default fetchArticles
